const accountInfo = {
  accountInfo: {
    account_information: 'マイアカウント情報',
    services: 'マイサービス',
    data_privacy: 'マイデータとプライバシー',
    benefits: 'メリット',
    company: '会社概要',
    branches: '支店',
    users: 'ユーザー',
    request_system_access: 'システムアクセスのリクエスト',
    authorized_subcontractor: '認定下請業者',
    area_coverage: 'サービスエリア',
    lead_program: 'リードの設定',
    ein_program: 'リードとEnphase Installer Network',
    //TODO - new translations added
    ac_module_admin: 'ACモジュール管理',
    training_dashboard: 'トレーニング',
    //TODO ends
    enphase_store: 'Enphase Store',
    product_warranty_extension: '製品保証の延長',
    lpp: '労働者保護プログラム',
    permit_assistance: '許可支援',
    incentive_programs: 'インセンティブプログラム',
    ein_merchandise: 'EINマーチャンダイズ',
    //TODO - new translations added
    design_tool: '設計および提案ツール',
    design_review_service: 'デザイン・レビュー・サービス',
    bom: 'BOM計算',
    //TODO ends
    financing: '資金調達',
    training: 'トレーニング',
    collaterals: 'コラテラル',
    my_leads: 'My Leads',
    lead_details: '見積依頼詳細',
    api_access: 'API アクセス',
    third_party: 'サードパーティレポート',
    profiles: 'グリッドプロファイル',
    createBranch: '支店の追加',
    branch_profile: '支店概要',
    new: '新規',
    applications: 'アプリケーション',
    createUser: '新規ユーザーの追加',
    user_profile: 'ユーザープロファイル',
    platform_discounts: 'プラットフォーム割引',
    account_details: 'アカウント詳細',
    preferences: '環境設定',
    change_password: 'パスワードの変更',
    account: 'アカウント',
    dashboard: 'ダッシュボード',
    systems: 'システム',
    admin: '管理者',
    einDashboard: 'EINダッシュボード',
    einAdmin: 'EIN管理者',
    edit: '編集',
    //TODO
    gotoSolargraf: 'Solargrafへ移動',
    createSolargrafAccountMessage:
      '%{email}で Solargrafの有効なアカウントが見つかりませんでした。アカウントを作成するか、サブスクリプションを購入してください。',
    createSolargrafAccountNote:
      '注意：すでにSolargrafのアカウントをお持ちの場合は、SolargrafのメールIDをEnlightenのメールに変更してください。',
    verificationText: '検証',
    solargrafOtpMessage:
      'あなたのメールに6桁の認証コードを送信しました。EnlightenマネージャーとSolargrafをリンクさせるには、以下のコードを入力してください。',
    enterOtpText: 'ワンタイムパスワードを入力',
    didntReceivedOtpMessage: 'ワンタイムパスワードを受け取っていませんか？',
    resendOtp: 'ワンタイムパスワードの再送信',
    verificationSuccess: '正常に検証されました！',
    verificationFailure: '誤った情報',
    otpExpired: 'ワンタイムパスワードは期限切れです。新しいワンタイムパスワードをリクエストしてください',
    otpSentSuccessfully: 'ワンタイムパスワードは正常に送信されました',
    otpSentFailed: 'ワンタイムパスワードの送信に失敗しました。後ほどもう一度お試しください',
    linkSolargrafTitle: 'Solargrafアカウントをリンクする',
    getVerificationCodeText: '認証コードを取得する',
    linkSolargrafMessageOne: 'このオプションを使用するには、EnlightenアカウントをSolargrafアカウントにリンクする必要があります。',
    linkSolargrafMessageTwo: 'このステップを完了するために、メールアドレスの確認が一度行われます。',
    rma_dashboard: '返品保証ダッシュボード',
    generator_tokens: '発電機トークン',
    data_plan_extension: "Mobile Connectデータエクステンション"
  }
};

export default accountInfo;
